import { render, staticRenderFns } from "./DeliveryTime.vue?vue&type=template&id=216695ca&scoped=true&"
import script from "./DeliveryTime.vue?vue&type=script&lang=js&"
export * from "./DeliveryTime.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryTime.vue?vue&type=style&index=0&id=216695ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216695ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
